import React from "react";
import { Link } from "react-router-dom";

import HeroImg from "../../../images/template-hero.png";
import HeroBanner from "../../../images/template-hero.jpg";

import Head from "../../Head/Head";
import NavBar from "../../NavBar/NavBar";
import ContactUs from "../../Forms/ContactUs/ContactUs";
import Footer from "../../Footer/Footer";
import Prefer from "../../Prefer/Prefer";
import Offices from "../../Offices/Offices";
import InstantQuote from "../../InstantQuote/InstantQuote";

import "./CertifiedTemplate.css";

const Document = ({ location, type }) => {
  return (
    <div className="template position-relative">
      <Head
        title={`${type} services in ${location} | certified ${type} translators in ${location}`}
        description={`Get ${type} services in ${location} with top certified ${type} translators in ${location}. We offer ${type} services in ${location} in over 250 languages.`}
        keywords={`translation, interpretation, certified, services, language, conference interpreter, document, localization, translators, interpreter, translator, translation company, translation services, translation companies, translation agencies, document translation, translation services near me, translate document, document translation service, document translation services online, simultaneous interpretation services, multilingual services, sworn translators, certified translations, ${type}, ${location}`}
      />
      <NavBar />
      <div className="template__hero container overflow-hidden d-flex f-50 align-center justify-between position-relative z-1">
        <div className="f-50 my-40">
          <div className="d-flex flex-column align-start justify-center">
            <h2 className="text-capitalise font-heading text-capitalise">
              {type} in {location} at Your Finger Tips
            </h2>
            <p className="font-bigger mt-40">
              We provide {type} in {location} at the most professional level
              bearing client specifics and interest at the core of our services.
            </p>
            <a
              href="/quote"
              className="template__link mt-40 py-10 px-20 font-bold"
            >
              REQUEST A QUOTE
            </a>
          </div>
        </div>
        <div className="d-flex flex-row-reverse justify-end overflow-hidden f-50">
          <img className="d-flex" src={HeroImg} alt="" />
        </div>
      </div>
      <img className="template__banner my-20" src={HeroBanner} alt="" />
      <div className="template__sec1 container d-flex flex-column align-center justify-between">
        <div className="">
          <h2 className="text-capitalise font-heading">
            The best certified document translation services in {location}
          </h2>
          <p className="my-40 lh-lg font-heavy">
            Oneconverse is a certified translation company in {location} that
            offers document translation service. It is the best document
            translation services in {location}. Oneconverse’s certified
            translators are well-versed in various languages, cultures, and
            formats to ensure that your documents are translated accurately and
            quickly. Whether you need your content to be translated into another
            language or need to make edits for international audiences,
            Oneconverse has dedicated teams of professionals who can help you
            translate your documents quickly and accurately. Pricing varies
            based on the type of services required and the number of words to be
            translated. Oneconverse is a certified translation company in{" "}
            {location}. We are the best document translation services in the{" "}
            {location}. Oneconverse is proud to be one of the leading document
            translation services providers in the {location}. Our translators
            are native speakers, trained professionals with significant
            experience translating documents for major corporations, law firms
            and individuals alike. Oneconverse offers certified document
            translation services in {location}. They have been providing their
            clients with the best translation services for over a decade.
            Oneconverse specializes in various types of industries that require
            a wide range of expertise and experience in the fields of IT,
            marketing, legal, medical and many more.
            <br />
            They have a team of professional translators who not only have the
            ability to translate documents from one language to another but can
            also do so according to your specific needs and requirements.
            Oneconverse has been helping organizations communicate with
            customers, employees and other stakeholders successfully for more
            than 10 years now.
          </p>
          <Link
            to="/quote"
            className="template__link my-40 py-10 px-20 font-bold"
          >
            REQUEST A QUOTE
          </Link>
        </div>
      </div>
      <div className="template__sec2 container">
        <h2 className="text-capitalise font-heading py-40 text-center mx-auto">
          Get Professional {type} right at your Finger Tips in {location}
        </h2>
        <p className="text-center mx-auto">
          We provide at easy and on time, various quality professional {type} in{" "}
          {location} without sacrificing the quality
        </p>
        <div className="py-40">
          <ul className="grid c-5 gap-20 list-none mb-40">
            <li className="border-1 py-20 px-10 text-left text-capitalise">
              • content translation
            </li>
            <li className="border-1 py-20 px-10 text-left text-capitalise">
              • certificate translation
            </li>
            <li className="border-1 py-20 px-10 text-left text-capitalise">
              • audio translation
            </li>
            <li className="border-1 py-20 px-10 text-left text-capitalise">
              • website translation{" "}
            </li>
            <li className="border-1 py-20 px-10 text-left text-capitalise">
              • video translation
            </li>
            <li className="border-1 py-20 px-10 text-left text-capitalise">
              • Technical translation
            </li>
            <li className="border-1 py-20 px-10 text-left text-capitalise">
              • legal translation
            </li>
            <li className="border-1 py-20 px-10 text-left text-capitalise">
              • Academic translation
            </li>
            <li className="border-1 py-20 px-10 text-left text-capitalise">
              • proposal translation
            </li>
            <li className="border-1 py-20 px-10 text-left text-capitalise">
              • content localization
            </li>
            <li className="border-1 py-20 px-10 text-left text-capitalise">
              • book translation
            </li>
            <li className="border-1 py-20 px-10 text-left text-capitalise">
              • media translation
            </li>
          </ul>
        </div>
      </div>
      <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
        <div className="f-50">
          <div>
            <h2 className="text-capitalise font-heading py-40">
              Oneconverse is the certified document translation services in{" "}
              {location}
            </h2>
            <p className="lh-lg font-heavy">
              One of the most common certified document translation services in{" "}
              {location} is certified document translation services. certified
              document translation services in {location} are often needed when
              a legal institution, embassy or governmental agency requires
              documents to be translated from one language to another. Another
              example is business document translation services such as
              financial document translations, real estate document translations
              or legal document translations.When companies need certified
              document translations in {location} they usually go to document
              translation services in {location} that are certified skillful
              professional document translators to avoid document translation
              problems. Looking for certified document translation services in{" "}
              {location}
            </p>
          </div>
        </div>
      </div>
      <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
        <div className="f-50">
          <div>
            <h2 className="text-capitalise font-heading py-40">
              Our capacity in providing document translation services in{" "}
              {location}
            </h2>
            <p className="lh-lg font-heavy">
              Oneconverse is a trusted certified translation company in{" "}
              {location} , offering certified document translation services in{" "}
              {location} . We're best known among the top translation companies
              in world for our trusted document translation services in{" "}
              {location}.There are several document translation companies in{" "}
              {location}, but not all of them can provide high-quality document
              translation services like document translation company or document
              translation firms. According to statistics, only 10 percent of the
              population own a document translation machine which means that you
              should be able to provide better document translations than other
              people because this might be your competitive edge and you will
              definitely be ahead of them if your quality of document
              translations is far more superior than theirs.The best thing about
              providing document translation services is that it is done quickly
              with accuracy without sacrificing any detail added in the original
              document including images, pictures, symbols, colors and fonts.
              <br />
              While document translation services are vital to the success of
              business operations, it is usually considered as a tedious process
              especially to those who have very limited knowledge about document
              translation. To provide document translation services to our
              clients in {location} , we start with document assessment.
              Oneconverse streamlined processes is an assurance in translation
              quality delivery.
              <br />
              When providing document translation services, it is important that
              you know what kind of documents they need translated so you can do
              it with utmost accuracy and attention to detail. Sometimes, people
              think that human translations are all the same but this is not
              true at all because some translations require high-level expertise
              concerning linguistic skills such as cultural references between
              document translation and document proofreading for document
              translation services.
            </p>
          </div>
        </div>
      </div>
      <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
        <div className="f-50">
          <div>
            <h2 className="text-capitalise font-heading py-40">
              Why Oneconverse is the best certified document translation
              services in {location}
            </h2>
            <p className="lh-lg font-heavy">
              Document translation companies in {location} have different
              document translation types to be chosen from. Price is an
              important factor in the selection process, but so is quality.
              Certified document translations are generally more expensive than
              non-certified document translations because they are produced by
              qualified document translators. Looking for certified document
              translation services in {location}? Oneconverse is an highly rated
              certified document translation services in {location}
              <br />
              Document translation companies in {location} are required to
              provide document translation services in {location} by having
              certified document translators, experienced document translators
              and document translation proofreaders among their employees. This
              helps them provide good quality document translations for their
              customers. If you want to avoid document translation problems
              choose a document translation company that offers certified
              document translations . Oneconverse offers certified document
              translation services in {location}.<br />
              When looking for document translation services in {location},
              consider document translation companies certified by ISO 9001 or
              other document translation related certifications. Oneconverse is
              a certified translation company in {location} that provide
              certified document translations that are recognized worldwide and
              uses qualified certified document translators.
              <br />
              Another thing to remember is that not all document translations
              can be performed simultaneously, so if you need your document
              translated quickly you should check the deadlines set by document
              translation companies in {location} and choose one that allows
              document translations within the time frame you require.If you
              need document translation services, choose a document translation
              company certified by ISO 9001 and ask for certified document
              translations to avoid document translation problems. We provident
              urgent certified document translation services in {location}.
            </p>
          </div>
        </div>
      </div>
      <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
        <div className="f-50">
          <div>
            <h2 className="text-capitalise font-heading py-40">
              Oneconverse, Trusted certified document translation services in{" "}
              {location}
            </h2>
            <p className="lh-lg font-heavy">
              One of the most important services that certified document
              translation agency in {location} provides is the accurate,
              certified and perfect certified translation service. Oneconverse
              is the best document translation service in {location}.What makes
              Oneconverse different from other document translation companies or
              translation agencies in {location} are several factors, but
              primarily it's quality of certified translations not being
              translated by someone who is fluent in both languages but also
              having at least some knowledge of the culture, legal system etc
              ... this way they can convey information more accurately. Document
              conversion is completed by native speakers of the target language
              specializing in translating various types of business related
              documents including contracts, financial reports, immigration
              documents and many others. Certified for an international standard
              certified translations offer a service that meets all necessary
              requirements.
            </p>
          </div>
        </div>
      </div>
      <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
        <div className="f-50">
          <div>
            <h2 className="text-capitalise font-heading py-40">
              Affordability and rates
            </h2>
            <p className="lh-lg font-heavy">
              One of the most important services that certified document
              translation agency in {location} provides is the accurate,
              certified and perfect certified translation service. Oneconverse
              is the best document translation service in {location}.What makes
              Oneconverse different from other document translation companies or
              translation agencies in {location} are several factors, but
              primarily it's quality of certified translations not being
              translated by someone who is fluent in both languages but also
              having at least some knowledge of the culture, legal system etc
              ... this way they can convey information more accurately. Document
              conversion is completed by native speakers of the target language
              specializing in translating various types of business related
              documents including contracts, financial reports, immigration
              documents and many others. Certified for an international standard
              certified translations offer a service that meets all necessary
              requirements.
              <br />
              Oneconverse is a translation services company that provides
              low-cost professional translations of all kinds. Our dedicated
              staff and their years of experience have provided us with the
              knowledge needed to help our clients, regardless of how small or
              large they might be. In addition to being able to handle any
              document on your list, we also offer free revision for each
              completed project.Our prices are very affordable, which makes us
              stand out from the competition in many ways. We take pride in
              being one of the cheapest translation service providers in{" "}
              {location} . Compared to other companies, Oneconverse has much
              lower rates; something that is great news for you, especially if
              you do not want expensive translation quotes anymore.Despite our
              low cost per word translations , we also make sure that your
              finished project is of the highest quality. We will not release it
              to our clients until we are fully confident that their documents
              are free from errors and completely ready for use.
            </p>
          </div>
        </div>
      </div>
      <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
        <div className="f-50">
          <div>
            <h2 className="text-capitalise font-heading py-40">
              Providing {type} at the most affordable prices
            </h2>
            <p className="lh-lg font-heavy">
              Our service packages vary according to client need, but regardless
              of what you select, you can expect the best results through
              friendly interactions with us throughout each project. All of them
              include free revision in case something needs changing or if you
              have additional requests for us.We offer several different
              language combinations , which means there is no longer a reason
              for you to spend more money than necessary on your translation
              projects anymore . Whether you require English to French
              translations or German to Italian services, Oneconverse has got
              you covered at all times. Our team is hard at work every day to
              ensure that every client receives the best possible experience, so
              give us a call today.Contact Oneconverse now for more information
              on our translation rates and services. We are sure you will be
              impressed by the results you will see!Affordable Low priced
              translations - one converse is your best choice!Oneconverse is a
              document translation service in {location} who offers low cost
              professional translations of all kinds. Our dedicated staff along
              with their years of experience have given us the knowledge needed
              to help our clients, regardless of what kind of document they need
              translated. In addition to being able to handle any type of file,
              we also offer free revision for each project that is completed.
              Our prices are very affordable, which makes us stand out.
            </p>
          </div>
        </div>
      </div>
      <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
        <div className="f-50">
          <div>
            <h2 className="text-capitalise font-heading py-40">
              Our translation quality Assurance
            </h2>
            <p className="lh-lg font-heavy">
              Translation quality is a constantly evolving process. We had to
              change our processes constantly to stay competitive, and we have
              constantly been looking for ways to improve our translation
              quality. This is why we are the best certified document
              translation service in {location}, as the trusted document
              translation service in {location}, we provide high quality
              document translation services in {location} and across the
              world.We have invested into the latest technologies that allow us
              to translate texts in a more accurate and human-like way, while
              also keeping the text readable. No document translation companies
              in {location} do it like us.
              <br />
              The key to a good document translation is finding a certified and
              experienced translator with the right qualifications. Our company
              understands the importance of providing the best possible
              translations, and we offer competitive rates and fast turnaround
              times.When you need certified translations, we can help you with
              all your needs. Our company is made up of professional translators
              that specialize in different industries such as legal, healthcare,
              tourism, and more. We also offer document translation services for
              any language combination and written format (including
              literature).
              <br />
              Translation is the conversion of text from one language to
              another. It may be done for reasons such as to communicate with
              people who speak another language, to facilitate trade between
              people who speak different languages, or to provide accessibility
              for people with different disabilities.The best document
              translation service in {location} is Oneconverse. We are a team of
              certified translators and subject matter experts (SMEs) that
              specializes in translating any kind of document for our clients.
              It doesn't matter if the documents you need translated are
              technical or legal; we can handle it all!
              <br />
            </p>
          </div>
        </div>
      </div>
      <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
        <div className="f-50">
          <div>
            <h2 className="text-capitalise font-heading py-40">
              Our translators pedigree
            </h2>
            <p className="lh-lg font-heavy">
              Worried about document translation services in the {location}?
              Oneconverse is a document translation company with expert
              translators. Translation companies in the {location} face
              significant challenges when hiring top-level document translators,
              as those talented individuals tend to work independently and be
              open to working for multiple companies at once. This is not an
              issue that we've encountered here at Oneconverse: our document
              translation team consists of only the most reliable and
              experienced translators who have worked together on thousands of
              document translation projects all over the world. Here's just a
              few reasons why we're confident you'll love working with us:
              <br />
              We offer very competitive prices for document translation services
              in the {location} compared to most other companies out there
              including even low quality online transcription tools such ashile
              document translation services are vital to the success of business
              operations, it is usually considered as a tedious process
              especially to those who have very limited knowledge about document
              translation. To provide document translation services to your
              clients in {location} , you must first start with document
              assessment. You can check or ask for Asian document translation
              and document proofreading so there will be no delay in your
              document delivery and compliance to established deadlines.
              <br />
            </p>
          </div>
        </div>
      </div>
      <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
        <div className="f-50">
          <div>
            <h2 className="text-capitalise font-heading py-40">
              Certified Translation in {location} for Any Industry, Any
              language.
            </h2>
            <p className="lh-lg font-heavy">
              One document translation services covering all languages in the{" "}
              {location} is Converse. Our document translation services are best
              for any industry in {location} because we have certified
              translators for each language.Translation companies are plentiful,
              but it can be hard to find one that will meet your specific needs.
              While many document translation services offer a large number of
              language combinations, they may not be able to do so with the
              necessary certifications and accreditations. And when you need
              document translation in legal matters or business transactions,
              only certified document translation agencies in {location} should
              be considered.Why choose document translation services over other
              modes of communication? Simply put, the process of document
              translation allows you to communicate more effectively with people
              who don't speak your language. It's an indispensable tool when
              completing document translation in {location} for any industry,
              from business document translation to certified document
              translation.There are a number of document translation services
              that offer various combinations of languages. However, some may
              not be able to deliver on the promise of quality document
              translation, due to limitations within their internal processes or
              through lack of certification by recognized agencies. For some
              industries, particularly international business operations or
              legal matters requiring document translation in {location}, only
              certified document translations are acceptable.Converse is your
              one-stop document translation services company in {location} with
              branches around the world and experienced professionals who have
              been certified by the American Translators Association (ATA). We
              provide you with high-quality certified document translations that
              can help you meet communication needs—whether they involveWe
              provide you certified document translation services in {location}{" "}
              by certified translators skilled In their respective languages.
            </p>
          </div>
        </div>
      </div>
      <Prefer />
      <Offices />
      <ContactUs />
      <div className="container">
        <InstantQuote />
      </div>
      <Footer />
    </div>
  );
};

export default Document;
